module.exports = __webpack_public_path__ + "static/media/stock.cb230685.png";